const medicineProductBt = {
	breadcrumbs: {
		home: 'ཁྱིམ་',
		medicineBazar: 'སྨན་ཚོང་ཟོར་'
	},
	loading: 'ལྷོད་སྒོར་འགྲོ་དོ...',
	labels: {
		prescriptionRequired: 'འཆང་འབྲི་དགོས།',
		reviewsSuffix: 'བསམ་འཆར་',
		deliveryPrefix: 'གཏོང་ལེན་:',
		minOrderPrefix: 'ཉོ་ཚོང་ཉུང་མཐའ་:',
		perUnitPrefix: 'རེ་རེ་',
		expiry: 'དུས་ཡུན་རྫོགས་:',
		stock: 'ཚོང་མང་:',
		inStock: 'ཡོངས་སུ་ཡོད་',
		outOfStock: 'མེད་',
		availableUnitsSuffix: 'ཐོབ་ཚུགས་',
		selectQuantity: 'གྱངས་ཁ་གདམ།:',
		unitLabel: 'ཆ་ཕྲན་',
		unitStrip: 'སི་ཊིརིཔ་',
		unitBox: 'སྒྲོམ་',
		unitTablet: 'ཊེབ་ལེཊ་',
		unitBottle: 'བོཊལ་',
		unitVial: 'བི་ཡལ་',
		unitAmpule: 'ཨེམ་པུལ་',
		unitTube: 'ཊུབ་',
		unitSachet: 'ས་ཤེཊ་',
		unitInhaler: 'ཨིན་ཧེ་ལར་',
		perUnitNotePrefix: '* རེ་རེ་',
		totalAmountPrefix: 'བསྡུས་བཅད་:',
		addToCart: 'ཀརཊ་ནང་བཙུགས།',
		wishlistAria: 'འདོན་ཐོ་ནང་སྣོན།',
		shareAria: 'རུབ་སྤྲོད།',
		descriptionTab: 'འགྲེལ་བཤད་',
		specsTab: 'ཁྱད་ཆོས་',
		reviewsTab: 'བསམ་འཆར་',
		productDescriptionTitle: 'སྨན་འགྲེལ་བཤད་',
		productSpecsTitle: 'སྨན་ཁྱད་ཆོས་',
		customerReviewsTitle: 'མཁོ་མང་མིའི་བསམ་འཆར་',
		relatedTitle: 'འབྲེལ་ཡོད་སྨན་'
	},
	messages: {
		addedToCart: 'ཀརཊ་ནང་བསྣན་ཡོད།',
		orderInfo: 'སྨན་ཚུགས་ཚང་མ་ ཆོག་འཐུས་ཕར་མ་སི་ནས་བྱིན་ཏེ་ཡོད་...'
	}
};

export default medicineProductBt;


